import React, { forwardRef } from 'react';
import { X } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { Colors, IconButton, Sizes } from 'shared/components/ui/icon-button';

import * as Styled from './meta-interaction.style';

export type MetaInteractionProps = {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  placeholder: string;
  label?: string;
  onClick?: () => void;
  end?: React.ReactNode;
  onClear?: () => void;
  selected?: boolean;
};

export const MetaInteraction = forwardRef<HTMLDivElement, MetaInteractionProps>(
  ({ icon, placeholder, label, onClick, end, onClear, selected }, ref) => {
    const _onClear = (e: React.MouseEvent) => {
      if (!onClear) {
        return;
      }

      e.stopPropagation();
      onClear();
    };

    return (
      <Styled.Container $selected={selected} onClick={onClick} ref={ref}>
        <Styled.IconContainer>
          <Icon icon={icon} />
        </Styled.IconContainer>
        <Styled.Label $isPlaceholder={!label}>
          {label ?? placeholder}
        </Styled.Label>
        {(end || onClear) && (
          <Styled.EndContainer>
            {!!end && <Styled.PostfixContainer>{end}</Styled.PostfixContainer>}
            {onClear && (
              <Styled.ClearContainer>
                <IconButton
                  icon={X}
                  size={Sizes.Small}
                  color={Colors.Default}
                  onClick={_onClear}
                />
              </Styled.ClearContainer>
            )}
          </Styled.EndContainer>
        )}
      </Styled.Container>
    );
  },
);
